export default __webpack_public_path__ + "static/media/T840_RoHS.f6e07ec8.pdf";